import { useId } from "react";
import styles from "./brewbase-icon-anim.module.css";

export default function BrewbaseIconAnim({
  progress,
}: {
  progress: number;
}) {
  const grayScaleMaskId = useId();
  const colorMaskId = useId();

  const startY = 6;
  const endY = -16;
  const translateY = (1 - progress / 100) * (startY - endY) + endY;

  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 400 400"
      xmlSpace="preserve"
    >
      <title>Brewbase Logo</title>
      <mask
        id={grayScaleMaskId}
        fill="white"
        className={styles["grayscale-mask"]}
      >
        <g
          className="transition-transform"
          style={{ transform: `translateY(${translateY}rem)` }}
        >
          <path d="m -509.9,160.405 0,67.59962 c 70.8,0 106.9,14.70038 141.7,29.00038 34.9,14.3 71,29 142.10001,29 71,0 107.2,-14.8 142.100004,-29 34.8,-14.2 70.9,-29 141.700016,-29 70.8,0 106.9,14.7 141.7,29 34.9,14.3 71,29 142.1,29 71.09999,0 107.19999,-14.8 142.09999,-29 34.8,-14.2 70.9,-29 141.7,-29 70.8,0 106.9,14.7 141.7,29 34.9,14.3 71,29 142.1,29 l 0,-632.20001 -1419.00002,0 z" />
        </g>
      </mask>
      <mask id={colorMaskId} fill="white" className={styles["color-mask"]}>
        <g
          className="transition-transform"
          style={{ transform: `translateY(${translateY}rem)` }}
        >
          <path d="m 909.1,353.4 0,-67.6 c -70.8,0 -106.9,-14.7 -141.7,-29 -34.9,-14.3 -71,-29 -142.1,-29 -71,0 -107.2,14.8 -142.1,29 -34.8,14.2 -70.9,29 -141.7,29 -70.8,0 -106.9,-14.7 -141.7,-29 -34.9,-14.3 -71,-29 -142.1,-29 -71.1,0 -107.2,14.8 -142.1,29 -34.8,14.2 -70.9,29 -141.7,29 -70.8,0 -106.9,-14.7 -141.7,-29 -34.9,-14.3 -71,-29 -142.1,-29 l 0,632.2 1419,0 z" />
        </g>
      </mask>
      <g id="grayscale-logo" mask={`url(#${grayScaleMaskId})`}>
        <path
          d="m152.69 9.0413c-3.2832 1.7922-5.3797 5.1796-5.5118 8.9176l0.14438 114.53-0.0144 63.172c-0.0133 3.2604 2.2149 5.8794 5.4493 5.8965 17.949 0.1001 27.566 0.14726 31.698 0.0715 6.5177 0.0858 16.648-11.954 16.559-19.36 0.11437-35.609 0.68194-70.74 0.4289-105.72-2.3046-28.085-20.426-47.349-38.266-67.322-3.5262-3.133-8.8458-1.0837-10.487-0.18728z"
          fill="#bbb"
        />
        <path
          d="m259.06 5.2445c-17.84 19.973-31.716 39.063-34.021 67.148 0 0 1.8394 81.42 2.2311 111.22-1.4732 12.57-7.6289 19.827-14.037 28.835-4.9587 6.7767-12.561 11.732-21.321 11.732h-40.825c-8.9256 0-13.384 5.786-17.517 11.902l-99.669 148.92c-3.3057 4.7932-0.17156 11.739 5.6147 11.739h43.802c7.6034 0 13.887-2.8118 18.019-8.7621l103.64-156.03c2.9522-4.3585 8.0234-6.7843 13.269-6.3387 5.2453 0.44605 9.8453 3.687 12.02 8.4812l6.2501 13.675 40.877 89.371 9.7445 20.671 13.52 29.935c4.1322 5.9502 10.659 9.0057 18.263 9.0057h41.689c5.0174 0 8.6601-3.8743 5.8659-10.35-7.3289-14.841-17.794-36.505-21.166-43.485l-52.284-113.46-17.162-37.249c-0.78915-2.3003-0.9264-3.1313-0.91639-5.7182-0.0144-14.136-0.0429-57.972-0.0429-57.972l0.14297-114.53c-0.12867-3.7381-2.2282-7.125-5.5114-8.9172-0.43747-0.23875-5.7182-4.0876-10.472 0.17727z"
          fill="#bbb"
        />
      </g>
      <g id="color-logo" mask={`url(#${colorMaskId})`}>
        <path
          d="m152.69 9.0413c-3.2832 1.7922-5.3797 5.1796-5.5118 8.9176l0.14438 114.53-0.0144 63.172c-0.0133 3.2604 2.2149 5.8794 5.4493 5.8965 17.949 0.1001 27.566 0.14726 31.698 0.0715 6.5177 0.0858 16.648-11.954 16.559-19.36 0.11437-35.609 0.68194-70.74 0.4289-105.72-2.3046-28.085-20.426-47.349-38.266-67.322-3.5262-3.133-8.8458-1.0837-10.487-0.18728z"
          fill="#f08942"
        />
        <path
          d="m259.06 5.2445c-17.84 19.973-31.716 39.063-34.021 67.148 0 0 1.8394 81.42 2.2311 111.22-1.4732 12.57-7.6289 19.827-14.037 28.835-4.9587 6.7767-12.561 11.732-21.321 11.732h-40.825c-8.9256 0-13.384 5.786-17.517 11.902l-99.669 148.92c-3.3057 4.7932-0.17156 11.739 5.6147 11.739h43.802c7.6034 0 13.887-2.8118 18.019-8.7621l103.64-156.03c2.9522-4.3585 8.0234-6.7843 13.269-6.3387 5.2453 0.44605 9.8453 3.687 12.02 8.4812l6.2501 13.675 40.877 89.371 9.7445 20.671 13.52 29.935c4.1322 5.9502 10.659 9.0057 18.263 9.0057h41.689c5.0174 0 8.6601-3.8743 5.8659-10.35-7.3289-14.841-17.794-36.505-21.166-43.485l-52.284-113.46-17.162-37.249c-0.78915-2.3003-0.9264-3.1313-0.91639-5.7182-0.0144-14.136-0.0429-57.972-0.0429-57.972l0.14297-114.53c-0.12867-3.7381-2.2282-7.125-5.5114-8.9172-0.43747-0.23875-5.7182-4.0876-10.472 0.17727z"
          fill="#f08942"
        />
      </g>
    </svg>
  );
}
